import React, { FC } from 'react'
import { Flex, Heading } from '@moonpig/launchpad-components'
import { IconSystemLocation } from '@moonpig/launchpad-assets'
import { ProductLocations } from './Components/ProductLocations'
import { useFindLocaleText } from '../../../text-localisation'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'

export const ProductLocationsModule: FC<ProductModule> = props => {
  const [
    {
      product: {
        variants: [{ locations }],
      },
    },
  ] = useProductContext()
  const localiseText = useFindLocaleText()

  if (!locations?.length) {
    return null
  }

  return (
    <ProductModuleSection {...props}>
      <Flex
        pt={{ xs: 10, md: 16 }}
        mt={{ xs: -10, md: -16 }}
        id="locations"
        width={1}
        flexDirection="column"
      >
        <Flex gap={6} alignItems="center" mb={6}>
          <IconSystemLocation width="1.2rem" height="1.2rem" />
          <Heading
            level="h2"
            mb={0}
            typography={{
              xs: 'typeMobileDisplay03',
              md: 'typeDesktopDisplay04',
            }}
          >
            {localiseText('find.product_locations_heading')}
          </Heading>
        </Flex>
        <Heading
          level="h3"
          mb={4}
          typography={{ xs: 'typeMobileDisplay04', md: 'typeDesktopDisplay05' }}
        >
          {localiseText('find.product_locations_summary', locations.length)}
        </Heading>
        <ProductLocations locations={locations} />
      </Flex>
    </ProductModuleSection>
  )
}
